export const productConfig = {
  brandName: 'CareersLaunching',
  defaultLanguage: 'en' as const,
  supportedLanguages: ['en', 'ar'] as const,
  contact: {
    whatsappNumber: '201111934374',
    assistedOfferMessage: 'I would like to Claim this Limited Time Offer for 50 EGP instead of 200',
  },
  journey: ['Build', 'Analyze', 'Match', 'Prepare', 'Get Job-Ready'] as const,
  ai: {
    promptVersions: {
      cvRewrite: 'cv_rewrite:v1',
      professionalSummary: 'professional_summary:v1',
      linkedinHeadline: 'linkedin_headline:v1',
      linkedinAbout: 'linkedin_about:v1',
      jobAnalysis: 'job_analysis:v1',
      interviewPack: 'interview_pack:v1',
      tellMeAboutYourself: 'tell_me_about_yourself:v1',
    },
    dailyUserLimit: 12,
    maxInputCharacters: 24_000,
  },
  session: {
    cookieName: '__Host-careerslaunching_session',
    maxAgeSeconds: 60 * 60 * 24 * 14,
  },
} as const;

export type FeatureKey =
  | 'career_profile'
  | 'cv_builder'
  | 'ats_classic_template'
  | 'deterministic_cv_score'
  | 'deterministic_linkedin_score'
  | 'basic_job_match'
  | 'sample_interview_questions'
  | 'premium_cv_templates'
  | 'ai_cv_rewrite'
  | 'ai_linkedin_rewrite'
  | 'deep_job_analysis'
  | 'full_interview_pack'
  | 'multiple_cv_versions'
  | 'advanced_exports';

export const planFeatures: Record<'free' | 'pro', readonly FeatureKey[]> = {
  free: ['career_profile', 'cv_builder', 'ats_classic_template'],
  pro: [
    'career_profile',
    'cv_builder',
    'ats_classic_template',
    'deterministic_cv_score',
    'deterministic_linkedin_score',
    'basic_job_match',
    'sample_interview_questions',
    'premium_cv_templates',
    'ai_cv_rewrite',
    'ai_linkedin_rewrite',
    'deep_job_analysis',
    'full_interview_pack',
    'multiple_cv_versions',
    'advanced_exports',
  ],
};

export function planCanUse(plan: 'free' | 'pro', feature: FeatureKey): boolean {
  return planFeatures[plan].includes(feature);
}

export function assistedOfferWhatsAppUrl(): string {
  return `https://wa.me/${productConfig.contact.whatsappNumber}?text=${encodeURIComponent(productConfig.contact.assistedOfferMessage)}`;
}
